import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableShimmer = ({ columns, startAction, endAction, enableAnimation = false }) =>
    [...Array(3)].map((_, i) => (
        <tr key={-i}>
            {[...Array(columns)].map((_, j) => {
                const action = (startAction && j === 0) || (endAction && j === columns - 1);
                return (
                    <td key={-j} padding={action ? "none" : "normal"}>
                        {!action && <Skeleton enableAnimation={enableAnimation} />}
                    </td>
                );
            })}
        </tr>
    ));

export default TableShimmer;
